import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=19af9559"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19af9559')) {
      api.createRecord('19af9559', component.options)
    } else {
      api.reload('19af9559', component.options)
    }
    module.hot.accept("./RoleList.vue?vue&type=template&id=19af9559", function () {
      api.rerender('19af9559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/role/RoleList.vue"
export default component.exports